import { FC, PropsWithChildren } from 'react';

const ApprovalContainer: FC<PropsWithChildren> = ({ children }) => {
  return <div className="px-4 sm:px-8 w-full py-8">{children}</div>;
};

export const CompanyPurchaseOrderApprovalDisplay: FC = () => {
  // const partnerId = usePartnerId();
  // const companyId = useCompanyId();
  // if (!partnerId || !companyId) throw new Error('Missing partner or company id');

  // const [purchaseOrderBundleResponse] = usePurchaseOrderBundle(partnerId, companyId);

  // const bundle = purchaseOrderBundleResponse[0];

  // const updateApproval = useUpdatePurchaseOrderApproval();

  // const navigate = useNavigate();
  // const onApproved = async () => {
  //   await updateApproval.mutateAsync({
  //     partnerId: partnerId,
  //     customerId: companyId,
  //     approved: true
  //   });
  // };
  // const onRejected = async () => {
  //   await updateApproval.mutateAsync({
  //     partnerId: partnerId,
  //     customerId: companyId,
  //     approved: false
  //   });
  // };

  // const [purchaseOrderApprovalResponse] = usePurchaseOrderApproval(partnerId, companyId);
  // useEffect(() => {
  //   if (!purchaseOrderApprovalResponse.needsApproval) navigate('/');
  // }, [purchaseOrderApprovalResponse]);
  //const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();

  return (
    <>
      <p>Approval TODO</p>
      {/* <div className="border-secondary-std border-b">
        <Container animate="fade" className="w-full py-3">
          <h2 className="font-bold text-3xl">Purchase order changes</h2>
          <span>
            Your purchase order prices have been updated. Please review the changes and accept or reject the updates.
          </span>
        </Container>
      </div>
      <ApprovalContainer>
        <h2 className="font-semibold text-2xl flex-1">Products</h2>
        <div className="flex flex-col space-y-10">
          {bundle.bundledItems.map(product => (
            <PurchaseOrderProductCard key={product.catalogItem} productId={product.catalogItem}>
              <div className="px-4 text-lg flex justify-center space-x-2 flex-row pb-3">
                <p>
                  Count: <span className="font-semibold">{product.count}</span>
                </p>
                <p>
                  Price:
                  <span className="font-semibold ml-2">
                    {printCurrencyString(product.price)}
                  </span>
                </p>
              </div>
            </PurchaseOrderProductCard>
          ))}
        </div>
      </ApprovalContainer>
      <div className="flex flex-col items-center justify-center max-w-7xl px-4 sm:px-8 w-full py-8">
        <div className="flex gap-4">
          <Button loading={updateApproval.isLoading} className="h-fit" onClick={onApproved}>
            <span>Accept changes</span>
          </Button>
          <Button loading={updateApproval.isLoading} className="h-fit" onClick={onRejected}>
            <span>Reject changes</span>
          </Button>
        </div>
      </div> */}
    </>
  );
};
